import { DataPlanner } from '../types'
import { planner as refResolving } from './refResolving/refResolver'

export const dataPlanners: Array<DataPlanner<any>> = [refResolving]
